import React from 'react';
import { connect } from 'react-redux';
import Price from '../../../utils/Price';

const ShortsDetail = (props) => {
    return (
      <div>
        <div className="imageHolder"><img src={props.image} alt="short img" /></div>
        <div className="textHolder">
          <div className="productName">
            {props.productName}
            <span className="price pullRight">
              <Price
                isTotal
                isTeamSport
                priceNet={props.unitNetPrice}
                currency={props.settings.currency}
              />
            </span>
          </div>
          <div className="customisationElement">
            <span className="customisationTitle">
              {props.generalTranslations.Size}
              {': '}
            </span>
            <span>{props.sizeName}</span>
          </div>

        {props.properties
          .filter(p => p.type === 'number')
          .map(
            (e, i) => {
              const id = Math.random + i;
              return (
              <div key={id}>
              { e.properties.render_value.length > 0 &&
                <div className="customisationElement">
                  <span className="customisationTitle ">
                    {props.generalTranslations.PlayerNumber}
                    {': '}
                  </span>
                  <span className="primaryValue">
                    {e.properties.render_value}
                    {' '}
                  </span>
                  <span className="price pullRight">
                    <Price
                      isTotal
                      isTeamSport
                      priceNet={e.price}
                      currency={props.settings.currency}
                    />
                  </span>
                </div>
              }
              </div>);
            },
          )
        }

        {props.properties
          .filter(p => p.type === 'sponsor_logo')
          .map(
            (e, i) => {
              const id = Math.random + i;
              return (
              <div key={id}>
              {
                <div className="customisationElement">
                  <span className="customisationTitle ">
                    {props.generalTranslations.SponsorLogo}
                    {': '}
                  </span>
                  <div className="price pullRight">
                    <Price
                      isTotal
                      isTeamSport
                      priceNet={e.price}
                      currency={props.settings.currency}
                    />
                  </div>
                </div>
              }
              </div>);
            },
        )}

        {props.properties
          .filter(p => p.type === 'club_logo')
          .map(
            (e, i) => {
              const id = Math.random + i;
              return (
            <div key={id}>
              {
                <div className="customisationElement">
                  <span className="customisationTitle ">
                    {props.generalTranslations.ClubLogo}
                    {': '}
                  </span>
                  <div className="price pullRight">
                    <Price
                      isTotal
                      isTeamSport
                      priceNet={e.price}
                      currency={props.settings.currency}
                    />
                  </div>
                </div>
              }
            </div>);
            },
          )
        }
        </div>
      </div>
    );
  };

const mapState = state => (
  {
    generalTranslations: state.generalTranslations,
    settings: state.settings,
  }
);

export default connect(mapState, null)(ShortsDetail);
